<template>
    <div id="ChildInformation">
        <router-link :to="{path:'/NewAddRecipientInfo', query:{from:'ChildInformation'}}">
            <div v-if='addShow' class="addBtn" @click="savePvUv">
                <span>添加子账号</span>
                <i class="iconfont icon-tianjia"></i>
            </div>
        </router-link>
        <div class="content" v-if='!lostTextShow && (item.receiver_list.length>0 || (Object.keys(item.receiver_list)).length>0)' v-for="(item,index) in dataArr" :key="index" :style="index!==0 ?'margin-top: 1.4vw;' :'margin-top: 0;'">
            <div class="contentTitle">
                <div class="stroeName">
                    <img :src="OSSBaseUrl+'stroeIcon.png'">
                    <p>{{item.visitor_nick}}</p>
                </div>
                <div class="deleBtn" @click="deleBtn(index)">
                    <p>删除接收人</p>
                </div>
            </div>
            <div class="contentItem">
                <div class="itemTitle">
                    <p style="margin-left: 8.5vw; width: 25vw">提醒人</p>
                    <p style="width: 20vw;padding-right:1.5vw;">提醒超时时间</p>
                    <p style="width: 20vw">监测消息类型</p>
                    <p style="width: 18vw;text-align:center">状态</p>
                </div>
                <div class="itemList" v-for="(_item,_index) in item.receiver_list" :key="_index" :style="_index == item.receiver_list.length-1 ?'border-bottom:none' :''">
                    <img :src="OSSBaseUrl+'noChoose.png'" v-if="!_item.active" alt="" @click="chooseActive(index, _index)">
                    <img :src="OSSBaseUrl+'chooseActive.png'" v-if="_item.active" alt="" @click="chooseActive(index, _index)">
                    <p style="margin-left: 3.5vw; width: 23.5vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{_item.receive_name}}</p>
                    <p style="width: 20vw;padding-left:2vw;padding-right:1.5vw;">{{_item.remind_time_set}}分钟</p>
                    <router-link :to="{path:'/MonitorType', query:{action:'edit',visitor_id:item.visitor_id,receiver_id:_item.id,receive_name:_item.receive_name,role_name:_item.role_name}}">
                        <p style="width: 19.5vw;color:#4577F3">查看</p>
                    </router-link>
                    <div>
                        <van-switch style="margin-left:1vw" @input="switch_touch(index, _index)" :value="_item.receive_msg_switch=='1'" active-color="#45DB5E" inactive-color="rgb(199,199,199)" />
                    </div>
                </div>
            </div>
        </div>
        <div class='lostText' v-if='lostTextShow'>
            <p>当前暂未添加子账号分流设置</p>
        </div>
        <div class="popupClass" v-if="popupShow">
            <Popup>
                <div class="deleDiv">
                    <p>是否删除该接收人？</p>
                    <p>删除后将不再与老板同步接收消息</p>
                    <div class="deleBtn">
                        <div @click="noDele">否</div>
                        <div @click="clickDeleBtn">是</div>
                    </div>
                </div>
            </Popup>
        </div>
        
        


    </div>
</template>

<script>
import { Switch , Toast , Checkbox , CheckboxGroup , Dialog } from 'vant';
import Popup from '@/components/Popup';

export default {
    data() {
        return {
            OSSBaseUrl: this.$OSSBaseUrl,
            popupShow: false,
            dataArr:[],
            addShow: false,
            lostTextShow: false
        }
    },
    components: { vanSwitch:Switch, Checkbox, CheckboxGroup, Dialog, Popup},
    mounted() {
        this.getDate()
    },
    methods: {
        getDate() {
            this.$store.dispatch('ChildInformation/getShuntSet',{}).then(res=>{
                if(res.code == 1000) {
                    console.log(res.data)
                    for(let i in res.data) {
                        for(let j in res.data[i].receiver_list) {
                            res.data[i].receiver_list[j].active = false
                        }
                    }
                    if(res.data.length==0) {
                        this.lostTextShow = true
                    }else {
                        this.lostTextShow = false
                    }
                    this.addShow = true
                    
                    this.dataArr = res.data
                }else {
                    Toast(res.message)
                }
                
            })
        },
        deleBtn(index) {
            this.deleIndex = index
            let arr = []
            for(let i in this.dataArr[index].receiver_list) {
                if(this.dataArr[index].receiver_list[i].active) {
                    arr.push(this.dataArr[index].receiver_list[i].active)
                }
            }
            if(arr.length > 0) {
                let typeArr = [];
                let activeArr = []
                for(let i in this.dataArr[index].receiver_list) {
                    if(this.dataArr[index].receiver_list[i].active) {
                        typeArr.push(this.dataArr[index].receiver_list[i].receive_msg_switch)
                        // 如果选中的有已经开启接收消息的
                        if(this.dataArr[index].receiver_list[i].receive_msg_switch == '1') {
                            activeArr.push(this.dataArr[index].receiver_list[i].receive_name)
                        }
                    }
                }
                let stroeStr = ''
                for(let i in activeArr) {
                    if(i == activeArr.length-1) {
                        stroeStr += `${activeArr[i]}`
                    }else {
                        stroeStr += `${activeArr[i]}子账号、`
                    }
                }
                if(activeArr.length > 0) {
                    Toast(stroeStr+'子账号正在接收消息不可删除')
                }
                // 判断删除的账号是否有接收消息的
                if (typeArr.findIndex((target) => target == '1') == -1) {
                    this.popupShow = true
                }
            }else {
                Toast('请先勾选要删除的接收人')
            }
        },
        switch_touch(index, _index) {
            if(this.dataArr[index].receiver_list[_index].receive_msg_switch == '0') {
                this.$store.dispatch('ChildInformation/setShuntSwitch',{id:this.dataArr[index].receiver_list[_index].id, receive_msg_switch:'1'}).then(res=>{
                    if(res.code == 1000) {
                        Toast('开启成功')
                        this.dataArr[index].receiver_list[_index].receive_msg_switch = '1'
                    }else {
                        Toast(res.message)
                    }
                })
                
            }else {
                this.$store.dispatch('ChildInformation/setShuntSwitch',{id:this.dataArr[index].receiver_list[_index].id, receive_msg_switch:'0'}).then(res=>{
                    if(res.code == 1000) {
                        Toast('关闭成功')
                        this.dataArr[index].receiver_list[_index].receive_msg_switch = '0'
                    }else {
                        Toast(res.message)
                    }
                })
            }
        },
        chooseActive(index, _index) {
            this.dataArr[index].receiver_list[_index].active = !this.dataArr[index].receiver_list[_index].active
            this.$forceUpdate()
        },
        savePvUv() {
            let data = {
                page_from:'main_page',
                page_name:'ChildInformation',
                btn_name: 'AddChildBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
            };
            this.$store.dispatch('Public/inH5Record', data)
        },
        noDele() {
            this.popupShow = false
        },
        clickDeleBtn() {
            let idList = []
            for(let i in this.dataArr[this.deleIndex].receiver_list) {
                if(this.dataArr[this.deleIndex].receiver_list[i].active) {
                    idList.push(this.dataArr[this.deleIndex].receiver_list[i].id)
                }
            }
            this.$store.dispatch('ChildInformation/delShuntAccount',{id:idList}).then(res=>{
                if(res.code == 1000) {
                    this.popupShow = false
                    Toast('删除成功')
                    this.getDate()
                    
                    // for(let i in idList) {
                    //     for(let j in this.dataArr[this.deleIndex].receiver_list) {
                    //         if(this.dataArr[this.deleIndex].receiver_list[j].id == idList[i]) {
                    //             this.dataArr[this.deleIndex].receiver_list.splice(j, 1)
                    //         }
                    //     }
                    // }
                }else {
                    Toast(res.message)
                }
                
            })
        }
    },
}
</script>

<style lang="scss" scoped>
    @import './index.scss';
</style>
<style lang="scss">
// 重写弹窗样式
.van-dialog__header {
    padding-top: 30px !important;
    font-size: 15px !important;
}
.van-dialog__message--has-title {
    padding-top: 15px !important;
    font-size: 15px !important;
}
.van-dialog__message {
    padding-bottom: 35px !important;
}
// [class*=van-hairline]::after {
//     border: none;
//     background-color: rgba(255, 255, 255, 0.1);
// }
.van-hairline--top::after {
    border-top: 2px solid #eff0f2 !important;
}
// .itemList div {
//     // 重写开关样式
//     .van-switch {
//         width: 70px;
//     }
//     .van-switch--disabled {
//         .van-switch__node {
//             left: 10px;
//         }
//     }
//     .van-switch--on {
//         .van-switch__node {
//             left: 10px;
//         }
//     }
// }

</style>